import {
    CLAPI
} from '../clchart/cl.api.js'
import * as Init from '../init.js';
import * as DATAS from '../datas/transdata.js'

export const FWIDTH = 130

export const CHART_OPTION_MCLASS = {
    style: 'horizontal', // 'vertical'
    title: {
        width: FWIDTH,
        label: '因子分类',
    },
    maxchs: 4,
    ctrls: []
}
// export const MINUTES = ['0945', '1045', '1330', '1445']

export const CHART_OPTION_MINUTE = {
    style: 'horizontal', // 'vertical'
    title: {
        label: '分时',
    },
    maxchs: 4,
    ctrls: []
}

const OPTION_GROUPS = 16
const OPTION_FIELDS = DATAS.fieldsToFieldsIndex('index,elenums,wnums,areav,weight,nums,rate')

function optionToUpdata(factorname, verify, assess) {
    // 先找 factorname
    let vars = []
    for (let index = 0; index < verify.datas.length; index++) {
        if (factorname !== CLAPI.getData(verify, 'cfname', index)) {
            continue
        }
        const ctyles = CLAPI.getData(verify, 'ctypes', index)
        for (let ii = 0; ii < ctyles; ii++) {
            // console.log(CLAPI.getData(assess, 'elenums' + ii.toString(), 0));
            vars.push([
                ii + 1, 
                CLAPI.getData(assess, 'elenums' + ii.toString(), 0),
                CLAPI.getData(assess, 'up_sums', 0),
                CLAPI.getData(verify, 'areas' + ii.toString(), index),
                CLAPI.getData(verify, 'upweight' + ii.toString(), index),
                CLAPI.getData(assess, 'up_nums' + ii.toString(), 0),
                CLAPI.getData(assess, 'up_rate' + ii.toString(), 0),
            ])
        }
        break;
    }
    return {
        fields: OPTION_FIELDS,
        datas: vars
    }
}

function optionToDndata(factorname, verify, assess) {
    // 先找 factorname
    let vars = []
    for (let index = 0; index < verify.datas.length; index++) {
        if (factorname !== CLAPI.getData(verify, 'cfname', index)) {
            continue
        }
        const ctyles = CLAPI.getData(verify, 'ctypes', index)
        for (let ii = 0; ii < ctyles; ii++) {
            vars.push([
                ii + 1, 
                CLAPI.getData(assess, 'elenums' + ii.toString(), 0),
                CLAPI.getData(assess, 'dn_sums', 0),
                CLAPI.getData(verify, 'areas' + ii.toString(), index),
                CLAPI.getData(verify, 'dnweight' + ii.toString(), index),
                CLAPI.getData(assess, 'dn_nums' + ii.toString(), 0),
                CLAPI.getData(assess, 'dn_rate' + ii.toString(), 0),
            ])
        }
        break;
    }
    console.log(vars);
    
    return {
        fields: OPTION_FIELDS,
        datas: vars
    }
}
export function optionToData(chartName, factorname, verify, assess) {
    if (chartName === 'UpChart') {
        return optionToUpdata(factorname, verify, assess)
    }
    else {
        return optionToDndata(factorname, verify, assess)
    }
}
export const CHART_OPTION_FACTORS = {
    style: 'vertical', // 'vertical'
    title: {
        label: '因子集',
        height: 23,
    },
    ctrls: []
}
export function setFactorsTitle(name) {
    CHART_OPTION_FACTORS.title.label = name
}
export function clearFactors() {
    CHART_OPTION_FACTORS.ctrls = []
}

export function incrFactors(fname, values) {
    // console.log(fname);
    const info = {
        label: CHART_OPTION_FACTORS.ctrls.length + '.' + fname,
        clickValue: fname,
        value : [],
    }
    if (values !== undefined && values.length > 0) {
        for (let index = 0; index < values.length; index++) {
            let clr = 'txt'
            if (values[index] > 0) {
                clr = 'red'
            }
            if (values[index] < 0) {
                clr = 'green'
            }
            info.value.push({
                label : Math.abs(values[index]),
                color : clr,
            })
        }
    }
    CHART_OPTION_FACTORS.ctrls.push(info)
}

export function onInit(classes, minutes) {
    CHART_OPTION_MCLASS.ctrls = []
    for (let wvi = 0; wvi < classes.length; wvi++) {
        CHART_OPTION_MCLASS.ctrls.push({
            label: classes[wvi],
            clickValue: classes[wvi],
        })
    }
    CHART_OPTION_MINUTE.ctrls = []
    for (let wvi = 0; wvi < minutes.length; wvi++) {
        CHART_OPTION_MINUTE.ctrls.push({
            label: minutes[wvi],
            clickValue: minutes[wvi],
        })
    }
}

////////////////////


export const CHART_OPTION_HEAD = {
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '' // 需要显示的文字信息
    },
    axisX: {
        lines: 0,
        display: 'whole',
        left: {
            display: 'normal', // chunk normal
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'none',
            getvar: 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    },
    axisY: {
        display: 'normal',
        lines: 3,
        left: {
            display: 'none', // none不显示，all, noupper不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'normal', // 是否有中间值 'before' = 前收盘 ‘zero’ 0为中间值
            format: 'double' // 输出数据的格式 rate, price, vol money
        },
        right: {
            display: 'both', // none不显示，noupper不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'normal', // 是否有中间值 'before'=前收盘 ‘zero’ 0为中间值
            format: 'double' // rate, price vol
        }
    },
    lines: []
}

export const LINES_OPTION_WEIGHT = [
    {
        className: CLAPI.ClDrawVBar,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['weight', 0.05], // 参与计算最大值的标签
            minvalue: ['weight', 0.0] // 参与计算最小值的标签
        },
        info: {
            filled: true,
            showstyle: 'zero', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'index',
            fieldY: 'weight', // 需要显示的变量，从key中获取对应的数据标签
            format: 'double',
        }
    }
]
export const LINES_OPTION_NUMS = [
    {
        className: CLAPI.ClDrawVBar,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['nums'], // 参与计算最大值的标签
            minvalue: [0] // 参与计算最小值的标签
        },
        info: {
            label : '有效样本数:',
            filled: true,
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'index',
            fieldY: 'nums', // 需要显示的变量，从key中获取对应的数据标签
            format: 'vol',
        }
    }
]

export const LINES_OPTION_SUMS = [
    {
        className: CLAPI.ClDrawVBar,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['elenums'], // 参与计算最大值的标签
            minvalue: [0] // 参与计算最小值的标签
        },
        info: {
            filled: true,
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'index',
            fieldY: 'elenums', // 需要显示的变量，从key中获取对应的数据标签
            format: 'vol',
        }
    }
]

export const LINES_OPTION_AREA = [
    {
        className: CLAPI.ClDrawVBar,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['areav'], // 参与计算最大值的标签
            minvalue: ['areav'] // 参与计算最小值的标签
        },
        info: {
            filled: true,
            showstyle: 'zero', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'index',
            fieldY: 'areav', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    }
]
export const LINES_OPTION_RATE = [
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['rate'], // 参与计算最大值的标签
            minvalue: ['rate'] // 参与计算最小值的标签
        },
        info: {
            filled: true,
            fieldX: 'index',
            fieldY: 'rate', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    }
]
